<h2 mat-dialog-title class="mb-0">Save board</h2>
<button mat-flat-button [mat-dialog-close]="false" mat-dialog-close>
    <img src="assets/icon-close.svg" width="14" height="auto" alt="close button" />
</button>

<div class="board-action">
    <p class="board-action__intro">
        You're viewing {{ useBrandivioBranding ? 'a Company board' : 'a Pattern board' }}, which is shared with everyone.
        How would you like to save your changes?
    </p>

    <button type="button" class="choice choice--copy" (click)="choose(PatternBoardAction.SaveCopy)" cdkFocusInitial>
        <span class="choice__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                    fill="currentColor"
                    d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
                />
            </svg>
        </span>
        <span class="choice__text">
            <span class="choice__title">Save a copy</span>
            <span class="choice__hint">
                Creates a new board under My Boards. The {{ useBrandivioBranding ? 'Company' : 'Pattern' }} board is left
                unchanged.
            </span>
        </span>
    </button>

    <button type="button" class="choice choice--shared" (click)="choose(PatternBoardAction.EditPatternBoard)">
        <span class="choice__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                    fill="currentColor"
                    d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                />
            </svg>
        </span>
        <span class="choice__text">
            <span class="choice__title">Edit {{ useBrandivioBranding ? 'Company' : 'Pattern' }} board</span>
            <span class="choice__hint choice__hint--caution">
                Updates the shared board itself &mdash; everyone will see these changes.
            </span>
        </span>
    </button>
</div>

<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
